import { Button, CodeEntry, Heading, Modal, Text } from '@afterpaytouch/core'
import { Trans, useTranslation } from 'next-i18next'
import React, { FunctionComponent, useContext } from 'react'
import { useCodeEntry } from '../../../../hooks'
import { useConsumerSelector } from '../../../../state'
import { useChangeMobileCheckEmailMutation, useChangeMobileReverifyEmailMutation } from '../../../../state/account/changeMobile'
import { EditMobileNumberModalContext, EditMobileNumberSteps } from '../../EditMobileNumberModal'

const I18N_NAMESPACE = ['common', 'account']

export const Init: FunctionComponent = () => {
  const { t } = useTranslation(I18N_NAMESPACE)
  const { codeEntryRef, codeEntryKey, resetCodeEntry } = useCodeEntry()
  const { email } = useConsumerSelector()
  const { token, setStep } = useContext(EditMobileNumberModalContext)

  const [reverifyEmail, { isLoading: isReverifyMobileLoading }] = useChangeMobileReverifyEmailMutation()

  const rerequestEmailCode = (): void => {
    reverifyEmail({ body: { token } })
  }

  const [checkEmail, { isError: isCheckEmailError, isLoading: isCheckEmailLoading }] = useChangeMobileCheckEmailMutation()

  const onCodeEntryComplete = async (code: string): Promise<void> => {
    try {
      await checkEmail({
        body: {
          code,
          token,
        },
      }).unwrap()
      setStep(EditMobileNumberSteps.Edit)
    } catch (err) {
      resetCodeEntry()
    }
  }

  const isCodeEntryDisabled = isReverifyMobileLoading || isCheckEmailLoading

  const testNameSpace = 'edit-mobile-number-modal-init'

  return (
    <>
      <Modal.Header divider>
        <div className='text-center'>
          <Heading testNameSpace={testNameSpace} size='L'>
            {t('account:edit:mobile:init:header:heading')}
          </Heading>
        </div>
      </Modal.Header>
      <Modal.Content>
        <div>
          <div className='mt-2'>
            <Text>{t('account:edit:mobile:init:content:message', { email })}</Text>
          </div>
          <div className='mt-4'>
            <CodeEntry
              codeEntryLength={6}
              onComplete={onCodeEntryComplete}
              disabled={isCodeEntryDisabled}
              error={isCheckEmailError}
              errorText={t('account:edit:mobile:init:content:code-entry:error')}
              testNameSpace={testNameSpace}
              ref={codeEntryRef}
              key={codeEntryKey}
            />
          </div>
          <div className='mt-6'>
            <Text size='S'>
              <Trans
                i18nKey='account:edit:mobile:init:content:resend'
                components={{
                  resendButton: <Button.Link size='Regular' onClick={rerequestEmailCode} />,
                }}
              />
            </Text>
          </div>
        </div>
      </Modal.Content>
    </>
  )
}
